import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Understanding Distributed Systems"
        desc="What every developer should know about large distributed applications"
        image="/images/books/understanding-distributed-systems.jpg"
        pageType="book"
        author="Roberto Vitillo"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/understanding-distributed-systems.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Understanding Distributed Systems
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Roberto Vitillo</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Roberto Vitillo distills years of experience building distributed systems into a
                practical, readable guide. The book covers the core challenges of distributed
                computing — communication, coordination, replication, consistency, and
                fault tolerance — without drowning you in academic theory.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Each chapter focuses on a real problem you will encounter when building systems
                that run across multiple machines: how networks fail, why clocks cannot be trusted,
                how to handle retries safely, and how consensus protocols actually work. If you are
                a backend engineer working with microservices, message queues, or cloud infrastructure,
                this book gives you the mental models to reason about reliability and design systems
                that handle failure gracefully.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
